import {schema as Schema} from 'normalizr';

export const filesAllSchemaEntity = new Schema.Entity('items', {}, {idAttribute: 'contentItemId'});
export const filesAllSchema = new Schema.Array(filesAllSchemaEntity);
